// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5102":"78e621ac70b58386","9829":"543d9eb2246d58e4"}[chunkId] + ".js";
};